// extracted by mini-css-extract-plugin
module.exports = {"level_0":"Comment_level_0__3_4Zo","level_1":"Comment_level_1__Duwug","level_2":"Comment_level_2__1Qxay","level_3":"Comment_level_3__1H5YH","level_4":"Comment_level_4__2Uoc2"};